import React from 'react';
import CorsGrid from './CorsGrid';
import FrameGrid from './FrameGrid';
import MimeGrid from './MimeGrid';
import Loader from '../../common/Loader';

const TAB_LABELS = { cors: 'CORS', frame: 'Frame', mime: 'MIME' };

const RuntimeConfigGrid = ({
  configId,
  document,
  loading,
  notFound,
  submitting,
  embedded,
  onEdit,
  onRemove,
}) => {
  if (loading) {
    return (
      <div className="runtime-config-loading" data-testid="runtime-config-grid-loading">
        <Loader />
      </div>
    );
  }

  if (!document) {
    return (
      <div className="runtime-config-banner runtime-config-banner-info" data-testid="runtime-config-grid-idle">
        No entries loaded. Click <strong>Browse</strong> to fetch the current{' '}
        {TAB_LABELS[configId] || configId} configuration.
      </div>
    );
  }

  const gridProps = {
    document,
    onEdit,
    onRemove,
    disabled: submitting,
  };

  const content = (
    <>
      {notFound && (
        <div
          className="runtime-config-banner runtime-config-banner-info"
          role="status"
          data-testid="runtime-config-not-found"
        >
          Config not seeded in this environment. Contact ops to run seed.
        </div>
      )}
      {configId === 'cors' && <CorsGrid {...gridProps} />}
      {configId === 'frame' && <FrameGrid {...gridProps} />}
      {configId === 'mime' && <MimeGrid {...gridProps} />}
    </>
  );

  if (embedded) {
    return <div data-testid="runtime-config-grid">{content}</div>;
  }

  return (
    <div className="runtime-config-grid-panel" data-testid="runtime-config-grid">
      {content}
    </div>
  );
};

export default RuntimeConfigGrid;
